<template>
    <div class="result2-records-container">
        <el-page-header @back="goBack" content="试卷导出记录">
        </el-page-header>
        <div class="xy-center">
            <el-input v-model="keyWord" placeholder="请输入关键字检索"></el-input>
            <el-button @click="searchExam" type="primary" class="ml-10"><i class="el-icon-search"></i></el-button>
        </div>

        <div>
            <el-table
                border
                :data="tableData"
                style="width:100%"
            >
                <el-table-column prop="Name" label="考试名称" width="580" > </el-table-column>
                <el-table-column prop="Qty" label="试卷数量" width="100"> </el-table-column>
                <el-table-column prop="CreateTime" label="导出时间" width="160"> </el-table-column>
                <el-table-column fixed="right" align="center" label="操作">
                    <template slot-scope="scope">
                         <el-button v-if="Date.now()<new Date(scope.row.ExportTime).getTime()"  style="padding:11px 25px" icon="el-icon-loading">导出中</el-button>
                         <el-button v-else type="primary" style="padding:10px 40px" @click="handleDownload(scope.row)">下载</el-button>
                         <el-button type="danger" style="padding:10px 40px" @click="handleDelete(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="records-pagination-container">
            <Pagination
                :pSize="pageSize"
                :total="count"
                @update:pSize="hanldepSize"
                @update:pageNo = "handlePageNo"
                :pageNo="pageIndex"
            />
        </div>
    </div>
</template>

<script>
import Pagination from "@/components/Pagination.vue"
import { GetDownLoadExamPaperWithStudentAnswerList,DelJobTask } from "@/api/manage"
export default {
    components: {
        Pagination
    },
    name: "exam-results2-records",
    data() {
        return {
            tableData: [],
            pageIndex: 1,
            pageSize: 10,
            keyWord: "",
            count: 1,
        }
    },
    created() {
        this.renderData(this.pageIndex, this.pageSize)
    },
    mounted() {
        window.addEventListener("keydown", (e) => {
            if (e.keyCode === 13) {
                this.searchExam()
            }
        })
    },
    methods: {
        async renderData(pageIndex, pageSize, keyWord) {
            try {
                let params = {
                    pageIndex,
                    pageSize,
                    keyWord
                }
                let { count, data } = await GetDownLoadExamPaperWithStudentAnswerList(params)
                data.forEach(item => {
                    item.ExportTime = item.ExportTime.replace(/-/g, "/")
                })
                this.tableData = data
                this.count = count
            } catch (err) {
                console.error(err)
            }
        },
        handleDelete(row){
            this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let res = await DelJobTask({id:row.Id})
                if(res.code===100){
                    this.$message({
                        type: 'info',
                        message: '删除成功'
                    });
                    this.renderData(this.pageIndex, this.pageSize)
                }
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        // 下载试卷
        handleDownload(row) {
            let a = document.createElement("a")
            a.download = row.Name;
            a.href = row.DoneFileUrl;
            a.click()
        },
        // 页面页数
        handlePageNo(page) {
            this.pageIndex = page
            this.renderData(this.pageIndex, this.pageSize, this.keyWord)
        },
        // 页面显示条数
        hanldepSize(max) {
            this.pageIndex = 1
            this.pageSize = max
            this.renderData(this.pageIndex, this.pageSize, this.keyWord)
        },
        // 搜索试卷
        searchExam() {
            if (this.keyWord.trim() && this.keyWord) {
                this.pageIndex = 1
                this.renderData(this.pageIndex, this.pageSize, this.keyWord)
            }
        },
        // 返回上级
        goBack() {
            this.$router.back()
        }
    }
}
</script>

<style lang="less" scoped>
    .result2-records-container{
        padding: 50px 30px;
        /deep/ .el-page-header{
            .el-page-header__left{
                color: rgb(147, 147, 149);
            }
        }
        .xy-center {
            display: flex;
            justify-content: end;
            margin: 20px 0;
            .el-input{
                width: 20%;
            }
            .ml-10{
                position: relative;
                left:-20px;
                width: 20px;
                border-radius: 0 4px 4px 0px ;
                padding: 10px 20px;
                .el-icon-search{
                    margin-left:-9px;
                    font-size: 18px;
                }
            }
        }
        .records-pagination-container {
            .my-pagination{
                display: block;
            }
        }
    }
</style>
